import { usePublicOrder } from "@babackapp/return-widget-components/queries/use-public-order";
import { Outlet, useParams } from "react-router-dom";
import { useWidgetLanguage } from "../hooks/use-widget-language";

// Loads the order before any child route renders. usePublicOrder suspends until
// the order is in cache — and the underlying load-with-items fetch stores the
// order-scoped session JWT as a side effect. Without this gate, a deep link
// straight to /order/:orderId/return-requests races the order self-fetch against
// the return-request search that needs that token, so the search can fire with an
// empty Authorization header. The identification page used to provide this
// sequencing implicitly by loading the order before navigating.
export function ReturnWidgetOrderLayout() {
  const { orderId } = useParams<{ orderId: string }>();
  const { data: order } = usePublicOrder(orderId!);
  // `lang` is resolved back-side from the Shopify customer locale, with the same
  // chain the return emails use, so the portal and the emails agree.
  useWidgetLanguage(order?.lang);
  return <Outlet />;
}
